__turbopack_context__.v({
  "card": "UmmFza_card",
  "cardClickable": "UmmFza_cardClickable" + " " + __turbopack_context__.i(248112)["focusOutline"],
  "cardLink": "UmmFza_cardLink" + " " + __turbopack_context__.i(248112)["focusOutline"],
  "content": "UmmFza_content",
  "date": "UmmFza_date",
  "imageContainer": "UmmFza_imageContainer",
  "subtitle": "UmmFza_subtitle",
  "title": "UmmFza_title",
});
